<template>
	<div>
		<el-row :gutter="40">
			<el-col :span="14">
		   		<!-- <p>На этой странице выводится Ваша коллекция предметов.</p> -->
		   		<data-tables :data="recipes.filter(data => !search || data.displayName.toLowerCase().includes(search.toLowerCase()))" :filters="currentFilters" style="width: 100%;" border ref="userCollection" @filter-change="filterChange" @sort-change="sortChange" @current-page-change="currentPageChange" :current-page="page" :page-size="pageSize" @size-change="sizeChange" @expand-change="expandHandler">
				    <el-table-column type="expand">
				    	<template slot-scope="scope">
				    		<!-- {{scope.row}} -->
				    		<el-row type="flex" justify="left" :gutter="40" v-if="scope.row.priceType == 'recipePrice'">
							  	<el-col :span="6">
						        	<el-row style="margin-bottom: 16px;">
							  			<el-col :span="24"><h2>Схема рецепта</h2></el-col>
							  		</el-row> 
							  		<el-row v-for="i in 3" style="margin-bottom: 16px;">
							  			<el-col :span="8" v-for="j in 3">
											<img @click="$router.push({name: 'edit item', params: {item: scope.row.ingredients[(i-1)*3+(j-1)], mod: scope.row.mods[(i-1)*3+(j-1)]}})" :src="scope.row.icons[(i-1)*3+(j-1)]" alt="" :title="scope.row.titles[(i-1)*3+(j-1)]" style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; border: 1px solid; background-color: rgba(0,0,0,.1);">
							  			</el-col>
							  		</el-row>
							  	</el-col>
							</el-row> 
							<p v-if="scope.row.priceType == 'customPrice'">Стоимость предмета установлена произвольной.</p>	
				      	</template>
				    </el-table-column>
				    <el-table-column label="Предмет" prop="displayName" sortable sort-by="displayName" :filters="filters" :filter-multiple="true">
				      <template slot-scope="scope">
				      	<el-image style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; margin-right: 5px;" :src="scope.row.image"></el-image>
				        <span>{{scope.row.displayName}}</span>
				      </template>
				    </el-table-column>
				    <el-table-column label="Стоимость" width="140" prop="price" sortable>
				      	<template slot-scope="scope">
				        	<span>{{scope.row.price}}</span>
				      	</template>
				    </el-table-column>
				    <el-table-column label="Опции" width="200" prop="options" align="right">
				    	<template slot="header" slot-scope="scope">
					        <el-input style="width: 100%; padding: 0;" v-model="search" size="mini" placeholder="Предмет"/>
					    </template>
				      	<template slot-scope="scope">
	 						<el-button size="mini" icon="el-icon-edit" @click="$router.push({name: 'edit item', params: {item: scope.row.item}})"></el-button>
	 						<el-button size="mini" icon="el-icon-delete" @click="removeItem(scope.row.mod, scope.row.item);"></el-button>
				      	</template>
				    </el-table-column>
			    </data-tables>
		   	</el-col>
		</el-row>
		<hr>
		<el-row :gutter="40">
			<el-col>
			    <p>На этой странице выводится Ваша коллекция предметов. Таблица состоит из трёх колонок. В первой колонке выводится иконка и наименование предмета. Во второй колонке выводится стоимость предмета. В третьей колонке выводятся кнопки редактирования и удаления предмета. По умолчанию предметы отсортированы по алфавитному порядку. Чтобы изменить текущую фильтрацию воспользуйтесь галочкой правее надписи "Предмет" в заголовке таблицы. В выпадающем списке выберите один или несколько интересующих Вас модификаций и нажмите на кнопку "Подтвердить". Так же есть возможность сбросить фильтрацию по модификациям, в этом случае отобразятся все предметы из коллекции, для этого нажмите на кнопку "Сбросить" в выпадающем списке. Если Вы хотите найти предмет по названию, то можете воспользоваться поисковым полем в шапке таблицы. Имеется возможность отсортировать предметы по их стоимости, воспользовавшись стрелочками сортировки правее надписи "Стоимость" в шапке таблицы. В случае отсутствия предметов по текущей фильтрации либо поисковому слову выводится надпись "Нет данных". Для перехода на страницу редактирования предмета из коллекции предметов нажмите на кнопку "Редактирование", находящуюся в правой части ряда с предметом. Эта кнопка имеет иконку карандаша. Для удаления предмета из коллекции нажмите на кнопку "Удаления", находящуюся в правой части ряда с предметом. Эта кнопка имеет иконку корзины. Перед иконкой предмета находится стрелочка-спойлер. При нажатии на неё раскроется рецепт предмета. Если цена предмета указана произвольной, то вместо рецепта будет надпись "Стоимость предмета установлена произвольной." Ниже таблицы находится её навигация/пагинация.</p>
			</el-col>    
		</el-row>
	</div>	
</template>

<script>
import {db, removeItem} from '../firebase.js';
import {modsList, setFilterAndSort, filterChange, sortChange, currentPageChange, sizeChange} from '../functions.js';
export default {
	data() {
		return {
			search: '',
    		tableName: 'userCollection',
    		recomputedRecipe: 0,
    		page: 1,
    		pageSize: 20,
    		filters: [],//все фильтры
    		currentFilters: [],//активные фильтры
		};
	},
	watch: {
		filters(){
			var self = this;
			if (self.filters.length > 0) {
				self.setFilterAndSort();
			};	
		},
	},
	computed: {
		recipes() {
			var self = this;
			var recipes = [];
			var recomputedRecipe = self.recomputedRecipe;
			var collection = self.$store.state.userCollection;
			self.filters = [];
			for (var prop in collection) {
				collection[prop].forEach((el)=>{
					el.icons = []; el.titles = []; el.mods = []; recipes.push(el);
				});
				if (collection[prop].length > 0) {
					self.filters.push(modsList.find((el)=> {return el.value == prop}));
				};
			};
			// console.log(self.$store.state.userCollection);
			return recipes;
		},
		/*itemCollectionFull: function() {
  			var self = this;
  			var itemCollectionFull = [];
  			for (var prop in self.$store.state.itemCollection) {
  				itemCollectionFull = itemCollectionFull.concat(self.$store.state.itemCollection[prop]);
  			};
  			return itemCollectionFull;
  		},*/
	},
	mounted() {
		var self = this;
		self.setFilterAndSort();
		this.$store.subscribe((mutation, state) => {
	      	switch(mutation.type) {
	        	case 'updateUserCollection':
					self.recomputedRecipe++;
	        	break;
	      	};
	    });
	},
	methods: {
		expandHandler(row, expandedRows, expanded) {
			var self = this;
			row.icons = ['','','','','','','','',''];
			row.titles = ['','','','','','','','',''];
			row.ingredients = ['','','','','','','','',''];
			row.mods = ['','','','','','','','',''];
			if (row.pattern) {
				row.pattern.forEach(function(el, i){
	        		el.split('').forEach(function(el, j){
	        			if (el != ' ') {
	        				// var item = self.itemCollectionFull.find(function(subEl){return subEl.name == row.key[el].item;});
	        				var item = self.$store.state.itemCollection[row.key[el].mod].find(function(subEl){return subEl.name == row.key[el].item;})
	        				row.icons[i*3+j] = item.image;
	        				row.ingredients[i*3+j] = item.name;
	        				row.mods[i*3+j] = item.mod;
	        				row.titles[i*3+j] = item.displayName + ': ' + row.key[el].price;
	        			};
	        		});
	        	});
	        };	
		},
		removeItem: removeItem,
		setFilterAndSort: setFilterAndSort,
		filterChange: filterChange,
		sortChange: sortChange,
		currentPageChange: currentPageChange,
		sizeChange: sizeChange,
	},    
};
</script>